import { Box, Flex } from "@chakra-ui/react";
import { keyframes } from "@chakra-ui/system";

interface Props {
  width?: string;
  height?: string;
}

const offset = 187;
const duration = "1.4s";

const rotator = keyframes`
  0%   { transform: rotate(0deg); }
  100% { transform: rotate(270deg); }
`;

const dash = keyframes`
  0% {
    stroke-dashoffset: ${offset};
  }
  50% {
    stroke-dashoffset: ${offset / 4};
    transform: rotate(135deg);
  }
  100% {
    stroke-dashoffset: ${offset};
    transform: rotate(450deg);
  }
`;

export function SjLoadingSpinner({
  width = "48px",
  height = "48px",
}: Props): JSX.Element {
  return (
    <Flex w="100%" align="center" justify="center">
      <Box
        as="svg"
        className="spinner"
        width={width}
        height={height}
        viewBox="0 0 66 66"
        // 회전 애니메이션
        animation={`${rotator} ${duration} linear infinite`}
      >
        <Box
          as="circle"
          className="path"
          fill="none"
          strokeWidth="6"
          strokeLinecap="round"
          cx="33"
          cy="33"
          r="30"
          strokeDasharray={offset}
          strokeDashoffset="0"
          transformOrigin="center"
          stroke={"#1272EF"}
          animation={`
            ${dash} ${duration} ease-in-out infinite
          `}
        />
      </Box>
    </Flex>
  );
}
